import { useEffect } from 'react'
import { useApolloClient } from '@apollo/client'
import { datadogRum } from '@datadog/browser-rum'
import { FETCH_USER } from 'src/graphql/layout'

export const useDatadogUserObserver = (authenticated?: boolean) => {
  const client = useApolloClient()

  useEffect(() => {
    if (authenticated) {
      client
        .query({ query: FETCH_USER })
        .then(({ data }) => {
          const { loggedInUser } = data || {}
          if (loggedInUser) {
            datadogRum.setUser({
              id: loggedInUser.id
            })
          }
        })
        .catch(() => {
          // TODO: 401 errors occur during initial page load before authentication is fully established.
          // This happens because Apollo Client makes GraphQL queries on mount, but session/auth cookies
          // may not be ready yet. We silently ignore errors here to prevent error modals from appearing.
          // Once auth is established, subsequent queries will succeed. This is acceptable since this
          // is a non-critical Datadog RUM user tracking feature.
        })
    }
  }, [authenticated, client])
}
